import axios from 'axios';
import { genericRoute } from '../../routes';
import { bindActionCreators } from 'redux';
import { USERS_LOGIN_TWITTER } from '../../constants/actions';
import { getLoginWithErrors } from '../../actions/users';
import { dispatchError } from '../../actions/errors';

const TWITTER_AUTH_COMPLETE = 'TWITTER_AUTH_COMPLETE';
const TWITTER_AUTH_FAILED = 'TWITTER_AUTH_FAILED';

export default class TwitterAuth {
	constructor() {
		this._receiveMessage = this._receiveMessage.bind(this);
	}

	login(dispatch) {
		return this._TWTLogin(genericRoute(false, 'api/account/twittersigninurl'), dispatch);
	};

	register(dispatch) {
		return this._TWTLogin(genericRoute(false, 'api/account/twittersignupurl'), dispatch);
	};

	_TWTLogin(path, dispatch) {
		let width = 550; let height = 300;
		let top = ((window.screen.height - height) / 4);
		let left = ((window.screen.width - width) / 2);
		let win = window.open(path, 'twitter-auth', `width=${width},height=${height},top=${top},left=${left}`);
		this.dispatch = dispatch;

		window.addEventListener('message', this._receiveMessage, false);
	}

	_receiveMessage(event) {
		if (event.data) {
			switch (event.data.result) {
				case TWITTER_AUTH_COMPLETE: {
					bindActionCreators(getLoginWithErrors, this.dispatch)();
					break;
				}
				case TWITTER_AUTH_FAILED:
				default: {
					const msg = event.data.message || 'Twitter Authentication failed.';
					this.dispatch(dispatchError({ message: msg }));
				}
			}
		}

		window.removeEventListener('message', this._receiveMessage);
	}
};



/** WEBPACK FOOTER **
 ** ./frontend/utils/social/twitter.js
 **/